import * as React from 'react';
import { UIHeading1 } from '@cian/ui-kit';

import { AgentsItem } from './components/AgentsItem';
import * as styles from './styles.css';
import { ContactsContainer } from '../../containers/Agents/Contacts';
import { ServiceBannerContainer } from '../../containers/ServiceBannerContainer';
import { InfoLink } from '../Builder/component/BuilderLinkBlock/InfoLink';
import { VerticalSlider } from '../VerticalSlider';
import { INewbuildingSeller } from '../../types/newbuilding/seller';

interface IBuildersAgentsProps {
  sellers: INewbuildingSeller[];
  title: string;
}

export function Agents({ sellers, title }: IBuildersAgentsProps) {
  return (
    <div className={styles['container']}>
      <div className={styles['header']} data-testid="AgentsBlock">
        <UIHeading1 as="h2">{title}</UIHeading1>
        <ServiceBannerContainer type="seller" isMultiSeller={sellers.length > 1} />
      </div>
      <VerticalSlider containerClass={styles['slider']}>
        {sellers.map(seller => (
          <AgentsItem
            key={seller.realtyUserId}
            name={seller.name}
            avatarUrl={seller.avatarUrl}
            listingLink={<InfoLink url={seller.offersForSale?.url} text={seller.offersForSale?.text} />}
            controls={<ContactsContainer seller={seller} />}
          />
        ))}
      </VerticalSlider>
    </div>
  );
}
